import { darkBlue, darkOrangePrimary } from 'src/styles/colors';
import { MandatesListType } from 'src/pages/Mandates/models';

export const getTableRowColor = (state: MandatesListType) => {
  return state === 'Active' ? darkBlue : darkOrangePrimary;
};
